import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'nr-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  constructor(private route: ActivatedRoute,
              private localStorageService: LocalStorageService,
  ) {
    this.localStorageService.setItem('country-changed-manually', JSON.stringify(false));
  }

  ngOnInit() {
    this.route.data.subscribe();
  }

}
